// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"b5a8951e","251":"b5a8951e","628":"b5a8951e","905":"b5a8951e"}[chunkId] + ".chunk.css";
};